<template>
  <div id="login" style="height: 100%">
    <div class="fullscreen" @click="toggleFullScreen"></div>
    <div class="formParent" id="formParent">
      <div class="formRight">
          <h3>管理员 · <span>登录</span></h3>
          <el-form :model="loginForm" ref="loginForm" status-icon>
            <el-form-item
              prop="username"
              label="账号"
              :rules="[{ required: true, message: '用户名不能为空', tigger: 'blur' }]"
            >
              <el-input
                type="text"
                v-model="loginForm.username"
                auto-complete="off"
                placeholder="请输入用户名"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="密码"
              prop="password"
              :rules="[{ required: true, message: '密码不能为空', tigger: 'blur' }]"
            >
              <el-input
                type="password"
                v-model="loginForm.password"
                auto-complete="off"
                placeholder="请输入密码"
              ></el-input>
            </el-form-item>
            <el-form-item style="height: 30px">
              <p class="aboutRegister" style="margin-bottom: 0">
                <a style="text-align: left"></a>
                <a style="text-align: right"></a>
              </p>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="submitForm('loginForm')"
                @keyup.enter="keyupSubmit"
                >登录</el-button
              >
            </el-form-item>
          </el-form>
        </div>
    </div>
  </div>
</template>

<style scoped>
#login {
  position: relative;
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 99999;
  height: 40px;
  line-height: 40px;
  color: #707070;
  background: rgba(255, 255, 255, 0.15);
  text-align: center;
  font-size: 12px;
}
</style>
<script>
import { axiosPost,axiosGet } from "@/assets/ajaxFn.js";
export default {
  data() {
    return {
      screenHeight: document.documentElement.clientHeight + "px",
      loginForm: {
        username: "",
        password: "",
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login();
        } else {
          return false;
        }
      });
    },
    toggleFullScreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();

      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    },
  async login() {
      // this.$router.push('/index');
    let loginUserId="";
    await axiosPost("/api/passport/login", this.loginForm, "JSON").then(
        (res) => {
          if (res.code == 0) {
            let data = res.data;
            sessionStorage.setItem("loginData", JSON.stringify(data));
            let permissions=res.data.permissions;
            sessionStorage.setItem('permission',JSON.stringify(permissions));
            // sessionStorage.setItem('token',res.data)
            loginUserId=data.id;
            // 
          }
        },
        (err) => {}
      );
      if(loginUserId){
        // this.toggleFullScreen();
        this.$router.push("/index");
      }
     },
    keyupSubmit() {
      document.onkeydown = (e) => {
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.login();
        }
      };
    },
  },
  created() {
    this.keyupSubmit();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/Login/login.vue